import NextLink from '@/components/next-link';
import useCategoryStore from '@/store/category.store';
import { event_category_click } from '@/utils/gtm';

const BreadCrumbItem = ({ item, href, isLast }) => {
  const menuTreeData = useCategoryStore((state) => state.menuTreeData);
  return (
    <div className='hover:text-primary flex items-center gap-2'>
      <span className='max-sm:relative max-sm:-top-0.5 max-sm:ps-0.5'>
        &nbsp;&gt;
      </span>
      {isLast ? 
        <span className='max-w-max min-w-max cursor-default text-sm font-bold whitespace-nowrap text-[#222] max-lg:text-[13px] max-md:text-xs max-sm:text-xs'>
          {item.name}
        </span>
       : (
        <NextLink
          className='max-w-max min-w-max text-sm font-bold whitespace-nowrap max-lg:text-[13px] max-md:text-xs max-sm:text-xs'
          href={href}
          prefetch={false}
          onClick={() =>
            event_category_click({
              menuTreeData,
              link: href,
              click_location: 'breadcrumb',
            })
          }
        >
          {item.name}
        </NextLink>
      )}
    </div>
  );
};

export default BreadCrumbItem;
